import type { MouseEvent } from 'react';

import type { AbstractCarouselSelectStrategy } from './AbstractCarouselSelectStrategy';
import type { CarouselSelectStrategyHandlerProps } from './models';

export class CarouselSelectHandler {
  private strategy: AbstractCarouselSelectStrategy;

  constructor(strategy: AbstractCarouselSelectStrategy) {
    this.strategy = strategy;
  }

  public handle(props: CarouselSelectStrategyHandlerProps, e: MouseEvent): void {
    this.strategy.handle(props, e);
  }
}
